import React from 'react';
    import { motion } from 'framer-motion';

    const TickTock = () => {
      return (
        <motion.div 
          className="fixed bottom-8 right-8 text-gray-600 text-xs font-mono tracking-widest opacity-40"
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.4 }}
          transition={{ delay: 2 }}
        >
          tick tock next block
        </motion.div>
      );
    };

    export default TickTock;